/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2021-08-06 16:04:46
 * @LastEditors: lkz
 */
import util from '../../views/work/util'
// state
const state = {
  send: 0,
  arrlist: [], // 所有数组
  index: 99, // 当前第几个
  leftnum: 0, // 0：当前对话、1：历史对话、2：正在排队
  showmid: false, // 显示中间和右边
  topfont: '2', // 顶部上线离线状态
  nowlist: {}, // 当前对话
  empIds: '', // 客服empid
  treecontent: '', // 点击快捷回复
  cleararr: false, // 清空所有记录
  oldflg: true, // 显示历史对话
  oldlist: [],
  oldnow: {}, // 当前历史对话
  fonttext: 0,
  dingdan: {},
  showZone: {
    message: false,
    quickReply: false
  },
  wsState: false, // webstock 链接状态
  wsConnetState: 2,
  midItemClick: {}, // 点击中间了的商品订单item
  startTypeEnum: [], // 工作台状态列表
  setOastate: {}, // 设置头部OA申请状态切换
  oldIndex: 99, // 历史对话当前点击第几个
  serviceOption: [], // 工作台服务小记公告列表
  threadData: { // 获取当前crm的线索
    channelId: '',
    channelContent: '',
    targetId: '',
    targetContent: ''
  },
  orderLesseeId: ''
}

// getters
const getters = {
  getSend: state => state.send,
  getArrlist: state => state.arrlist,
  getIndex: state => state.index,
  getleftnum: state => state.leftnum,
  getshowmid: state => state.showmid,
  gettopfont: state => state.topfont,
  nowlist: state => state.nowlist,
  empIds: state => state.empId,
  gettreecontent: state => state.treecontent,
  setclear: state => state.cleararr,
  oldflg: state => state.oldflg,
  oldlist: state => state.oldlist,
  oldnow: state => state.oldnow,
  getfonttext: state => state.fonttext,
  showZone: state => state.showZone,
  wsState: state => state.wsState,
  wsConnetState: state => state.wsConnetState,
  getMidItemClick: state => state.midItemClick,
  startTypeEnum: state => state.startTypeEnum,
  getsetOastate: state => state.setOastate,
  getoldIndex: state => state.oldIndex,
  serviceOption: state => state.serviceOption,
  getThreadData: state => state.threadData,
  getorderLesseeId: state => state.orderLesseeId
}

// actions
const actions = {
  setIndexval({ commit }, val) {
    // 当前第几个
    commit('SETINDEX', val)
  },
  setArr({ commit, state }, val) {
    // 每次获取消息都存起来
    if (val.cmd === 1) {
      if (val.content) {
        val.content = JSON.parse(val.content)
      }
      const checklist = util.checkarrflg(state.arrlist, val.content.consumerId)
      val.showclose = 0
      switch (val.onlineStatus) {
        case 1:
          val.onlineStatus = 2
          break
        case 3:
          val.onlineStatus = 0
          break
        default: break
      }
      if (!checklist.flg) {
        val.children = []
        val.read = 0
        val.choose = false
        // val.star = 1
        val.hasMessage = 0
        val.serviceCount = 0 // ?
        val.box = {} // ?
        val.userdata = {} // 用户信息-预留字段
        val.readnum = 0 // 消息数
        val.orderList = []
        val.imgList = []
        val.sessionId = val.content.sessionId
        // val.updateFirstResponseTime = true
        val.showclose = 0
        const time = (val.content.noReplyTime ? (new Date() - val.content.noReplyTime) : 0) || val.getTime || 0
        val.getTime = time // 影响刷新第一次进线有没有倒计时
        if (val.content.empNickName) {
          // 客服头像需求 empNickName用来区分客服信息和用户信息，防止推入用户信息 2019/8/6
          const newval = JSON.parse(JSON.stringify(val))
          val.children.push(newval)
        }
        state.arrlist.push(val)
      } else {
        state.arrlist[checklist.index].showclose = val.onlineStatus
        state.arrlist[checklist.index].sessionId = val.content.sessionId
        // state.arrlist[checklist.index].getTime = new Date() // 影响接收用户信息，并开始倒计时
        if (val.markStarLevel !== undefined) state.arrlist[checklist.index].markStarLevel = val.markStarLevel
        if (state.nowlist.content.consumerId === val.content.consumerId) {
          if (state.nowlist.content.sessionId !== val.content.sessionId) {
            state.nowlist.content = val.content
            state.nowlist.sessionId = val.content.sessionId
            state.nowlist.star = 1
            // val.updateFirstResponseTime = true
          }
        }
        if (state.arrlist[checklist.index].content.sessionId !== val.content.sessionId) {
          // state.arrlist[checklist.index].star = 1
          state.arrlist[checklist.index].content.sessionId = val.content.sessionId
          // state.arrlist[checklist.index].updateFirstResponseTime = true
        }
        if (val.reset == 1) {
          val.children = []
          val.choose = false
          val.hasMessage = 0
          val.userdata = {}
          val.orderList = []
          val.imgList = []
        }
      }
      commit('SETARRLIST', state.arrlist)
    } else if (val.cmd == 0 || val.cmd == 23) {
      let num = 99
      let flgs = false
      if (val.send == 1) {
        // 判断是否客服发送
        val.flg = 2
        flgs = true
        num = state.index
        if (val.type == 10) {
          if (val.content.orderPackageVoList && val.content.orderPackageVoList.length) {
            val.content.seldata = val.content.orderPackageVoList[0]
            val.content.nums = 0
          }
        }
        state.arrlist[num].getTime = 0
      } else {
        // 如果是用户发送消息
        if (val.cmd == 0 && val.fromType == 'POP') return
        state.arrlist.forEach((item, i) => {
          if (item.content.consumerId == val.from) {
            num = i
            flgs = true
            val.flg = 1
            const itemMsgid = item.children.find(j => j.msgId == val.msgId)
            if (itemMsgid) {
              flgs = false
            }
          }
        })
        if (state.arrlist[num]) {
          state.arrlist[num].readnum = state.arrlist[num].readnum += 1
        }
        // if ((val.cmd == 0 && (val.type == 1 || val.type == 2)) || val.type == 14) {
        //   val.content = JSON.parse(val.content)
        // }
        val = util.parseContent(val)
        if (state.arrlist[num] && !state.arrlist[num].getTime) state.arrlist[num].getTime = new Date()
      }
      if (state.index < 30) {
        state.arrlist[state.index].readnum = 0
      }
      if (flgs) {
        // state.arrlist[num].getTime = 0 // 影响客服清空倒计时，有问题要改
        state.arrlist[num].read = 0
        if (state.index < 90) {
          state.arrlist[state.index].read = 1
        }
        if (val.cmd === 0 && val.type === 3) { // 图片保存起来
          if (state.nowlist && state.nowlist.content.consumerId === val.from) {
            // 当前用户推送图片时
            state.nowlist.imgList.push(val.content)
          }
          // 非当前沟通用户推送图片时保存图片
          // todo lijg 下面三行代码导致用户发图片小计会添加重复图片
          const msgItem = state.arrlist.find(item => item.from === val.from)
          if (msgItem) msgItem.imgList.push(val.content)
          // for (let i = 0; i < state.arrlist.length; i += 1) {
          //   const { from } = state.arrlist[i]
          //   if (from.toString() === val.from) {
          //     if (state.arrlist[i].imgList.indexOf(val.content) === -1) state.arrlist[i].imgList.push(val.content)
          //   }
          // }
        }
        state.arrlist[num].box = val
        state.arrlist[num].children.push(val)
        commit('SETARRLIST', state.arrlist)
      }
    } else if (val.cmd == 2) {
      const checklist = util.checkarrflg(state.arrlist, val.from)
      if (checklist.flg) {
        val.showclose = val.type
        state.arrlist[checklist.index].showclose = val.type
        commit('SETARRLIST', state.arrlist)
      }
    } else if (val.cmd == 10) {
      if (window.location.href.indexOf('t.yunjiglobal.com') > -1) {
        window.location.href = 'http://tsso.yunjiglobal.com/index'
      } else {
        window.location.href = 'http://sso.yunjiglobal.com'
      }
    } else if (val.cmd === 3) {
      // const newcurlist = JSON.parse(JSON.stringify(state.arrlist))
      state.arrlist.forEach((i, v) => {
        if (i.content.consumerId == val.to) {
          i.children.forEach((j, k) => {
            if (j.msgId == val.msgId) {
              j.showgif = 3
              j.msgTime = val.msgTime
            }
          })
        }
      })
      // commit('SETARRLIST', newcurlist)
      if (state.nowlist.children) {
        state.nowlist.children = state.arrlist[state.index].children
      }
    }
  },
  setleft({ commit, state }, val) {
    // 保存左侧栏当前第几个
    commit('SETLEFTNUM', val)
  },
  setshowmid({ commit, state }, val) {
    // 显示中间和右边的开关
    commit('SETSHOW', val)
  },
  settopfont({ commit, state }, val) {
    // 顶部上线离线状态
    commit('SETFONTS', val)
  },
  setNewarrs({ commit, state }, val) {
    // 重新赋值arrlist
    commit('SETARRLIST', val)
  },
  setnowlist({ commit, state }, val) {
    commit('SETNOWLIST', val)
  },
  setempIds({ commit, state }, val) {
    commit('SETEMPIDS', val)
  },
  settreecontent({ commit, state }, val) {
    commit('SETTREECONTENT', val)
  },
  setcleararr({ commit, state }, val) {
    commit('SETCLEARARR', val)
  },
  setoldflg({ commit, state }, val) {
    commit('SETOLDFLG', val)
  },
  setoldlist({ commit, state }, val) {
    commit('SETOLDLIST', val)
  },
  setoldnow({ commit, state }, val) {
    commit('SETOLDNOW', val)
  },
  getfonttext({ commit, state }, val) {
    commit('GETFONTTEXT', val)
  },
  getdingdan({ commit, state }, val) {
    commit('GETDINGDAN', val)
  },

  setnowlistchildren({ commit, state }, val) {
    commit('SETNOWLISTCHILDREN', val)
  },
  setStartTypeEnum({ commit, state }, val) {
    commit('SETSTARTTYPEENUM', val)
  },
  /**
   * @description: 控制显示区域
   * @param {type}
   * @return:
   */
  setShowZone({ commit }, val) {
    commit('SETSHOWZONE', val)
  },
  /**
   * @description: 设置webstock状态
   * @param {type}
   * @return:
   */
  setWsState({ commit }, params) {
    commit('SET_WS_STATE', params)
  },
  /**
   * @description: 设置webstock连接状态
   * @param {*} param0
   * @param {*} params
   */
  setWsConnetState({ commit }, params) {
    commit('SET_WS_CONNET_STATE', params)
  },
  /**
   * @description: 设置中间商品卡片的点击item
   * @param {*} param0
   * @param {*} params
   */
  setMidItemClick({ commit }, params) {
    commit('SET_MID_ITEM_CLICK', params)
  },
  setSetOastate({ commit }, params) {
    commit('SETOASTATE', params)
  },
  /**
   * @description: 历史对话当前点击第几个
   * @param {*} param0
   * @param {*} params
   */
  setoldIndex({ commit }, params) {
    commit('SETOLDINDEX', params)
  },
  setserviceOption({ commit }, params) {
    commit('SETSERVICEOPTION', params)
  },
  setThreadData({ commit }, params) {
    commit('SETTHREADDATA', params)
  },
  setOrderLesseeId({ commit }, params) {
    commit('SETORDERLESSEEID', params)
  },
  setNowListByItem({ commit }, params) {
    commit('SETNOWLISTBYITEM', params)
  }
}
// mutations
const mutations = {
  SETARRLIST(state, val) {
    // 通知SETARRLIST
    state.arrlist = val
  },
  SETINDEX(state, val) {
    // 当前第几个
    state.index = val
  },
  SETLEFTNUM(state, val) {
    // 保存左侧栏
    state.leftnum = val
  },
  SETSHOW(state, val) {
    // 显示中间和右边的开关
    state.showmid = val
  },
  SETFONTS(state, val) {
    state.topfont = val // 顶部上线离线状态
  },
  SETNOWLIST(state, val) {
    // 历史对话

    if (val) {
      state.nowlist = val
    } else {
      state.nowlist = {}
    }
  },
  SETEMPIDS(state, val) {
    state.empIds = val
  },
  SETTREECONTENT(state, val) {
    state.treecontent = val
  },
  SETCLEARARR(state, val) {
    state.arrlist = []
    state.index = 0
    state.nowlist = []
    state.showmid = false
    state.cleararr = val
  },
  SETOLDFLG(state, val) {
    state.oldflg = val
  },
  SETOLDLIST(state, val) {
    state.oldlist = val
  },
  SETOLDNOW(state, val) {
    state.oldnow = val
  },
  GETFONTTEXT(state, val) {
    state.getfonttext = val
  },
  GETDINGDAN(state, val) {
    state.dingdan = val
  },
  SETNOWLISTCHILDREN(state, val) {
    state.nowlist.children = val
  },
  SETSHOWZONE(state, val) {
    state.showZone = Object.assign(state.showZone, val)
  },
  SET_WS_STATE(state, params) {
    state.wsState = params
  },
  SET_WS_CONNET_STATE(state, params) {
    state.wsConnetState = params // 状态有3中：  0是正常 1是重连中 2断开
  },
  SET_MID_ITEM_CLICK(state, params) {
    state.midItemClick = params
  },
  SETSTARTTYPEENUM(state, params) {
    state.startTypeEnum = params
  },
  SETOASTATE(state, params) {
    state.setOastate = params
  },
  SETOLDINDEX(state, params) {
    state.oldIndex = params
  },
  SETSERVICEOPTION(state, params) {
    state.serviceOption = params
  },
  SETTHREADDATA(state, params) {
    state.threadData = params
  },
  SETORDERLESSEEID(state, params) {
    state.orderLesseeId = params
  },
  SETNOWLISTBYITEM(state, params) {
    // console.log(state.nowlist.children[params].content)
    const random = new Date().getTime()
    const item = state.nowlist.children[params]
    item.content = `${item.content}?v=${random}`
    state.nowlist.children.splice(params, 1, JSON.parse(JSON.stringify(state.nowlist.children[params])))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
